var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 text-center"},[_c('div',{staticClass:"title mb-1"},[_vm._v(" Thank you for your submission. ")]),_c('h5',{staticClass:"mb-5"},[_vm._v(" We'll reach out to you shortly. ")]),_c('BaseLink',{attrs:{"render-as-button":"","to":"login"}},[_vm._v(" Back to Home ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }